import { createFileRoute } from "@tanstack/react-router";
import { SettingsPage } from "@/components/dashboard/settings-page";
export const Route = createFileRoute("/settings")({
 head:()=>({meta:[{title:"Settings — Deuxda Admin"},{name:"description",content:"Language, appearance and regional preferences for the Deuxda admin console."},{property:"og:title",content:"Settings — Deuxda Admin"},{property:"og:description",content:"Language, appearance and regional preferences for the Deuxda admin console."},{property:"og:type",content:"website"},{name:"twitter:card",content:"summary_large_image"}]}),
 component:()=> <SettingsPage/>,
});
